<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="140px">
            <el-form-item label="设备编号：" prop="code">
                <el-input v-model="model.code" disabled></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <el-input v-model="model.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="关联数据采集器：" prop="check_code">
                <el-select v-model="model.check_code" placeholder="请选择" clearable filterable style="width: 100%">
                    <el-option v-for="item in checkList" :key="item.id"  :label="item.code" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no">
                <el-select clearable v-model="model.channel_no" placeholder="请选择">
                    <el-option v-for="item in enuObj('channel_no')" :key="'channel_no'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备报警：" prop="alert_device">
                <el-radio-group v-model="model.alert_device">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="流量预警阈值：" prop="flow_threshold">
                <el-input v-model.number="model.flow_threshold" style="width: 150px"></el-input>（L/min）
            </el-form-item>
            <el-form-item label="压力预警阈值：" prop="pressure_threshold">
                <el-input v-model.number="model.pressure_threshold" style="width: 150px"></el-input>（Mpa）
            </el-form-item>
            <el-form-item label="抬动预警阈值：" prop="lift_threshold">
                <el-input v-model.number="model.lift_threshold" style="width: 150px"></el-input>（um）
            </el-form-item>
            <el-form-item label="流量差预警值：" prop="flow_cha">
                <el-input v-model="model.flow_cha" style="width: 150px"></el-input>（L/min）
            </el-form-item>
            <el-form-item label="压力差预警值：" prop="pressure_cha">
                <el-input v-model="model.pressure_cha" style="width: 150px"></el-input>（Mpa）
            </el-form-item>
            <el-form-item label="密度差预警值：" prop="density_cha">
                <el-input v-model="model.density_cha" style="width: 150px"></el-input>（(g/cm3)）
            </el-form-item>
            <el-form-item label="工作时间类型：" prop="work_time_type">
                <el-select clearable v-model="model.work_time_type" placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('work_time_type')" :key="'work_time_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作开始时间：" prop="work_time_start" v-if="model.work_time_type==2">
                <el-input v-model="model.work_time_start" style="width: 150px"></el-input>（格式如：07:00:00）
            </el-form-item>
            <el-form-item label="工作结束时间：" prop="work_time_end" v-if="model.work_time_type==2">
                <el-input v-model="model.work_time_end" style="width: 150px"></el-input>（格式如：14:00:00）
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getAllDeviceCheckList, getAllProducerList } from '@/api/deviceuser'

export default {
    name: 'deviceExtractEdit1',
    mixins: [editutil],
    data() {
        return {
            model: {
                check_id: '',
                check_code: '',
                check_name: '',
                channel_no: '',
                code: '',
                name: '',
                alias: '',
                model: '',
                time_difference: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                flow_threshold: 40,
                pressure_threshold: 3,
                lift_threshold: 100,
                work_time_type: '1',
                work_time_start: '',
                work_time_end: '',
                flow_cha: '',
                pressure_cha: '',
                density_cha: '',
                alert_device: '',
            },
            getObj:{
                url:'/api/admin/deviceextract/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['channel_no', 'work_time_type', 'device_type1'],
            rules: {
                code: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                alias: [
                    {required: true, message: '简称不能为空', trigger: 'blur'}
                ],
                model: [
                    {required: true, message: '型号不能为空', trigger: 'blur'}
                ],
                company_produce: [
                    {required: true, message: '生产厂家不能为空', trigger: 'blur'}
                ],
                device_type: [
                    {required: true, message: '设备类型不能为空', trigger: 'blur'}
                ],
                company_use: [
                    {required: true, message: '使用单位不能为空', trigger: 'blur'}
                ],                
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
                channel_no: [
                    {required: true, message: '通道号不能为空', trigger: 'blur'},
                ],
                flow_threshold: [
                    {required: true, message: '流量预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '流量预警阈值必须是数字值', trigger: 'blur'}
                ],
                pressure_threshold: [
                    {required: true, message: '压力预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '压力预警阈值必须是数字值', trigger: 'blur'}
                ],
                lift_threshold: [
                    {required: true, message: '抬动预警阈值不能为空', trigger: 'blur'},
                    {type: 'number', message: '抬动预警阈值必须是数字值', trigger: 'blur'}
                ],
                flow_cha: [
                    {required: true, message: '流量差值不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                pressure_cha: [
                    {required: true, message: '压力差值不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                density_cha: [
                    {required: true, message: '密度差值不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                work_time_type: [
                    {required: true, message: '工作时间类型不能为空', trigger: 'blur'},
                ],
            },
            checkObj:{
                url:'/api/admin/deviceextract/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
            checkList: [],
            producerList: [],
        };
    },
    methods: {
        loadOtherData() {
            getAllDeviceCheckList().then(res=>{
                if(res.code ==1){
                    this.checkList = res.data
                }
            })
            getAllProducerList().then(res=>{
                if(res.code ==1){
                    this.producerList = res.data
                }
            })
        },
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/deviceextract/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        checkDeviceChange(obj){
            if(this.$isNull(obj)){
                this.model.check_code = ''
                this.model.check_name = ''
            }else{
                this.model.check_code = obj.code
                this.model.check_name = obj.name
            }
        },
        formateData(){
            this.model.work_time_type = this.model.work_time_type+""
            this.model.device_type = this.model.device_type+""
            this.model.alert_device = this.model.alert_device+""
        },
    }
};
</script>